module.exports = __webpack_public_path__ + "static/media/cloud_infrastructure.ec10dcbe.svg";